import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addNotification } from '../actions/notificationActions';
import NotificationSystem from 'react-notification-system';

class NotificationContainer extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.notificationSystem = this.refs.notificationSystem;
    }

    componentWillReceiveProps(newProps) {
        const { message, level, autoDismiss } = newProps.notification;
        this.notificationSystem.addNotification({
            message,
            level,
            autoDismiss
        });
    }

    render() {
        return (
            <NotificationSystem ref="notificationSystem"
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        notification: state.notification
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            addNotification
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationContainer);


/** WEBPACK FOOTER **
 ** ./src/containers/Notification.js
 **/